/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import BasicModal from "examples/modal/BasicModal/BasicModal";
import FTextField from "components/Form/FTextField";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import pxToRem from "assets/theme/functions/pxToRem";

export default function RejectInquiryModal({
  open,
  handleClose,
  inquiry,
  handleConfirmReject,
  loading,
}) {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setReason("");
      setError("");
    }
  }, [open]);

  const onConfirm = () => {
    if (!reason || reason.trim() === "") {
      setError("Please enter a reason for rejection");
      return;
    }
    handleConfirmReject(inquiry, reason.trim());
  };

  return (
    <BasicModal
      open={open}
      handleClose={handleClose}
      title="Reject Inquiry"
      actionButton={loading ? "Rejecting..." : "Confirm Rejection"}
      handleAction={onConfirm}
      minWidth={550}
    >
      <MDBox mb={2}>
        <MDTypography variant="body2" sx={{ fontSize: pxToRem(14), color: "#475467" }}>
          Are you sure you want to reject inquiry{" "}
          <strong>{inquiry?.inquiryId ? `INQ-${inquiry.inquiryId}` : ""}</strong> for{" "}
          <strong>{`${inquiry?.firstName || ""} ${inquiry?.lastName || ""}`.trim()}</strong>?
        </MDTypography>
        <MDTypography variant="body2" sx={{ fontSize: pxToRem(13), color: "#667085", mt: 1 }}>
          Please enter the reason for rejection below. This inquiry will be updated to Rejected
          status.
        </MDTypography>
      </MDBox>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FTextField
            label="Reason for Rejection*"
            placeholder="Enter reason for rejection..."
            id="rejectionReason"
            name="rejectionReason"
            type="textarea"
            value={reason}
            handleChange={(e) => {
              setReason(e.target.value);
              if (error) setError("");
            }}
            error={Boolean(error)}
            helperText={error}
          />
        </Grid>
      </Grid>
    </BasicModal>
  );
}
